// Port of api/fuel/app/classes/filter/search/games/filters/query/game/language/count.php
export default {
	name: 'game.language.count',
	priority: 49,
	require: function(config, filter) { return filter.threshold && filter.threshold.language > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_language_count', '>=', filter.threshold.language)
	}
}
